export const SESSION_STORAGE = {
  SHOW_INCOMPLETE_REGISTER_WARNING: 'show_incomplete_register_warning',
};
